import {TranslateService} from '@ngx-translate/core';
import {DescriptionModel} from '../shared/description.model';

export class QuestionLiteModel {

  _id: string;
  name: string;
  names: DescriptionModel;
  representation: string;
  answerType: string;

  static generate(json: any): QuestionLiteModel {
    const q = new QuestionLiteModel();
    q._id = json._id;
    q.name = json.name;
    q.names = json.names;
    q.representation = json.representation;
    q.answerType = json.answerType;
    return q;
  }

  static generateList(jsonList: any[]): QuestionLiteModel[] {
    return jsonList.map(j => QuestionLiteModel.generate(j));
  }

  translatedName(culture: string): string {
    if (this.names && this.names[culture]) {
      return this.names[culture];
    }
    return this.name;
  }

  translatedRepresentation(tSv: TranslateService): string {
    return tSv.instant('representationTypes.' + this.representation);
  }

  translatedAnswerType(tSv: TranslateService): string {
    return tSv.instant('answerTypes.' + this.answerType);
  }

}
